<template>
  <page-outline :title="$t('businessDocuments.form_document_scan_title')" 
    icon="icon-sent" returnUrl="/home/">
    <template slot="pageContent">

      <div class="">
        <!-- File Type -->
        <form > 
          <b-row>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                :inputLabel="$t('businessDocuments.document_type')"
                :inputType="'listeSelect'" :mandatoryErrorIndicator="fileTypeSelectedError">
                <select class="form-control" id="sel2" readonly v-model="fileTypeSelected">
                  <option value="">{{ $t('businessDocuments.slct_doct_type') }}</option>
                  <option v-for="fileType in fileTypeList" :key="fileType.fileTypeValue"
                    :disabled="fileType.disabled"
                    :value="fileType.fileTypeValue"
                    :style="fileType.disabled ? 'font-style:italic;' : ''">
                    {{ $t(fileType.fileTypeLabel) }}
                  </option>
                </select>
              </form-write-group-label-input>
              <input class="item-input hiddenElementAllSize local-file-input" ref="fileButton" @change="executeOCR" type="file"/>
              <input class="hiddenElementAllSize" type="text"></input>
              <input class="hiddenElementAllSize" type="text" id="recommendation-list-input"></input>
              <div v-if="fileArrayError" style='color:red;'>
                {{ $t('errors.is_mandatory', {mandatoryValue: $t('attachments.import_file_singular') }) }}
              </div>
              <b-row>
                <b-col v-if="this.fileNameArray.length != 0" sm="12" lg="12" class="form-group mt-2">
                  <table class="table table-hover" style="table-layout:fixed">
                    <th class="border-0" v-if="this.fileNameArray.length > 1">Documents scannés</th>
                    <th class="border-0" v-else>Document scanné</th>
                    <tbody>
                      <tr v-for="(filename, i) in this.fileNameArray" class="border-bottom" :key="i">
                        <td class="border-0 p-1 fs-6 m-0">
                          <p class="d-flex justify-content-between align-items-baseline m-0 p-0">
                          {{ i + 1 }}
                            <a href="" @click="downloadFile(i)">
                              {{ filename }}
                            </a>
                            <a href="#" @click="removeFile(filename)">
                              <i class="icon button-delete f7-icons">close</i>
                            </a>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="6" class="form-group">
              <!-- DRAG AND DROP -->
              <div @dragover="onDragOver">
                <div class="dragDrop dragDropRest d-flex justify-content-center flex-column align-items-center mt-4" @click="showFileSelectionWindow(locationTypeFile)" @drop="handleDrop" @dragover.prevent @dragleave="onDragLeave">
                  <f7-icon fa="cloud-upload" style="font-size: 30px"></f7-icon>
                  <p class="font-size: 14px text-center">Glissez votre fichier ou <br>
                    <span class="font-size: 14px"><u>Parcourir vos dossiers</u></span><br>
                    <span class="text-gray fs-6"><i>(formats acceptés pdf, jpg, jpeg, png)</i></span>
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </form>

        <div v-if="serialize">
          <template v-for="(element, index) in serialize">
            <form-accordion :title="fileNameArray[index]" :key="index" class="mt-2">
              <b-row>
                <div class="spinner-container">
                  <span v-if="!serialize[index].ocrDone" class="spinner-border" role="status"></span>
                  <!-- Arrêter le load si la requête échoue pour pas le faire tourner dans le vide indéfiniment peut être avec set time out -->
                  <!-- <span v-else-if="serialize[index].ocrDone.status === 500 || serialize[index].ocrDone === false">Erreur: {{serialize[index].ocrDone.status}}</span> -->
                </div>
                <template v-for="value in serializeGet[index]">
                  <template v-if="(value.change === '1' && serialize[index][value.name] !== '') || (value.change === '0' && serialize[index][value.name])">
                    <template v-if="value.type === 'object'">
                      <b-col sm="10" v-for="(subvalue, subindex) in value[0]" :key="subindex">
                        <form-write-group-label-input
                          v-model="serialize[index][value.name][0][subindex.name]"
                          :inputLabel="$t('businessDocuments.serialize.' + fileTypeSelectedArray[index] + '.' + subindex.name)">
                        </form-write-group-label-input>
                      </b-col>
                    </template>
                    <b-col sm="10" v-else-if="value.type === 'date'">
                      <form-write-group-label-input v-model="serialize[index][value.name]"
                        :inputType="'date'"
                        :inputLabel="$t('businessDocuments.serialize.' + fileTypeSelectedArray[index] + '.' + value.name)"
                        :placeholderValue="$t('common.slct_date')">
                      </form-write-group-label-input>
                    </b-col>
                    <div v-else-if="value.type === 'boolean' && value.change === '0'" class="form-group col-sm-10">
                      <label>{{ $t('businessDocuments.serialize.' + fileTypeSelectedArray[index] + '.' + value.name) }}</label>
                      <div v-if="serialize[index][value.name] === '0'">
                        <i class="icon fa fa-check" style="color:green;font-size:30px;"></i>
                        &nbsp;&nbsp;{{ $t('common.status.valid_control_key') }}
                      </div>
                      <div v-else>
                        <i class="icon fa fa-ban" style="color:red;font-size:30px;"></i>&nbsp;&nbsp;
                        <span v-if="serialize[index][value.name] === '1'">
                          {{ $t('errors.invalid_control_key') }}
                        </span>
                        <span v-else-if="serialize[index][value.name] === '2'">
                          {{ $t('errors.out_of_date') }}
                        </span>
                        <span v-else-if="serialize[index][value.name] === '3'">
                          {{ $t('errors.invalid_control_key_out_of_date') }}
                        </span>
                      </div>
                    </div>
                    <b-col sm="6" class="form-group" v-else>
                      <form-write-group-label-input v-model="serialize[index][value.name]"
                        :inputLabel="$t('businessDocuments.serialize.' + fileTypeSelectedArray[index] + '.' + value.name)">
                      </form-write-group-label-input>
                    </b-col>
                  </template>
                </template>
              </b-row>
            </form-accordion>
          </template>
        </div>
      </div>
    </template>
  </page-outline>
</template>
<script>
import documentSerialize from '@/helpers/documentSerialize.json'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Services from '@/helpers/services'
import {verifyMandatoryValues, verifyRegexpValues, checkErrorFlag} from '@/helpers/validator'

/** @author TLV 05/11/2020
* @brief Component for sending Business Documents
*/
export default {
  name: 'OCRScanForm',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      fileReference: '',
      fieldsTypeMap: {},
      fileArrayError: false,
      fileContent: '',
      fileContentArray: [],
      fileEvent: '',
      fileId: '',
      fileName: '',
      fileNameArray: [],
      fileTypeList: [],
      fileTypeSelected: '',
      fileTypeSelectedArray: [],
      fileTypeSelectedError: false,
      folderId: '',
      folderIdError: false,
      folderName: '',
      folderNameError: false,
      lastIndex: 0,
      locationTypeFile: '1',
      ocrDone: false,
      recipientEmail: '',
      recipientEmailError: false,
      recipientEmailRegexpError: false,
      recipientName: '',
      recipientNameError: false,
      serialize: [],
      serializeGet: []
    }
  },
  created () {
    this.$engine.ocr.ocrRequestResult({})
    .then(response => {
      console.log(response)
    })
    .catch(err => {
      this.$f7.hidePreloader()
      this.$f7.closeModal()
      this.$f7.alert(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
      console.log(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
    })
    let keys = Object.keys(documentSerialize)
    for (var i = 0; i < keys.length; i++) {
      let fileType = {}
      fileType.fileTypeValue = keys[i]
      fileType.fileTypeLabel = documentSerialize[keys[i]].label
      fileType.disabled = documentSerialize[keys[i]].disabled
      this.fileTypeList.push(fileType)
      for (var j = 0; j < documentSerialize[keys[i]].fields.length; j++) {
        let field = documentSerialize[keys[i]].fields[j]
        this.fieldsTypeMap[field.name] = field.type
      }
    }
  },
  methods: {
    clearFile () {
      this.fileContent = ''
      this.fileName = ''
      this.fileReference = ''
      this.fileId = ''
      this.fileTypeSelected = ''
    },
    clearFileArrays () {
      this.fileNameArray = []
      this.fileContentArray = []
    },
    downloadFile (index) {
      this.$f7.showPreloader(this.$i18n.t('common.dwnldng_fl'))
      let downloadLink = document.createElement('a')
      downloadLink.download = this.fileNameArray[index]
      let fileContent = this.fileContentArray[index]
      downloadLink.href = fileContent
      this.$f7.hidePreloader()
      downloadLink.click()
    },
    // Load file from browser and start OCR, if current parameters allow it
    executeOCR (e) {
      if (e === '' && this.fileEvent === '') {
        return
      } else if (e === '') {
        e = this.fileEvent
      }
      var files = (e.target && e.target.files) || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 3000000) {
        var reader = new FileReader()
        reader.onload = (event) => {
          this.fileContent = event.target.result
          this.fileContentArray.push(event.target.result)
          if (this.$engine.settings.get(Services.DOCUMENTSERVICE).ocrActivation === '0' &&
              this.fileContentArray.length > 1) {
            console.log('OCR features are currently under maintenance. Please come again later.')
          } else if (this.fileTypeSelected === '') {
            this.fileEvent = e
          } else {
            this.ocrDone = false
            if (this.fileTypeSelected === 'FACTUR-X') {
              this.executeFacturX(reader.result)
              return
            }
            this.serialize[this.lastIndex].ocrDone = false
            return this.$engine.ocr.ocrRequest(
              this.$engine.user.get().id,
              '',
              event.target.result,
              'pdf',
              'scan',
              this.fileTypeSelected
            ).then(response => {
              response = response.data.ControlsInformations
              let attributes = Object.keys(response)
              for (let i = 0; i < attributes.length; i++) {
                this.serialize[this.lastIndex][attributes[i]] = response[attributes[i]].Value
              }
              this.serialize[this.lastIndex].ocrDone = true
              this.fileEvent = ''
            })
            .catch(err => {
              this.serialize[this.lastIndex].ocrDone = true
              this.$f7.hidePreloader()
              this.$f7.closeModal()
              this.$f7.alert(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
              console.log(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
            })
          }
        }
        this.fileName = files[0].name
        this.fileNameArray.push(files[0].name)
        this.setFileTypeSelected()
        if (this.fileTypeSelected) {
          this.setSerialize()
        }
        reader.readAsDataURL(files[0])
        this.Dom7(this.Dom7('.fileNameDisplay')[this.Dom7('.fileNameDisplay').length - 1]).val(this.fileName)
      } else {
        this.$f7.alert(this.$i18n.t('creation_forms.file_size') + Math.round(files[0].size / 1000) + this.$i18n.t('creation_forms.max_file_size') + '300 Mo',
          this.$i18n.t('creation_forms.max_size_title'))
      }
      this.$refs.fileButton.value = ''
    },
    filesPicker (e) {
      this.locationTypeFile = '2'
      e.stopPropagation()
      this.cloudDocsPicker.open()
    },
    handleDrop (e) {
      e.preventDefault()
      let droppedFiles = e.dataTransfer.files
      if (!droppedFiles) {
        return
      } else {
        droppedFiles.forEach(file => {
          this.executeOCR(e)
        })
      }
    },
    onDragOver (e) {
      if (e.target.classList.contains('dragDropRest')) {
        e.target.classList.remove('dragDropRest')
        e.target.classList.add('dragDropActive')
      }
    },
    onDragLeave (e) {
      if (e.target.classList.contains('dragDropActive')) {
        e.target.classList.remove('dragDropActive')
        e.target.classList.add('dragDropRest')
      }
    },
    removeFile (filename) {
      let index = this.fileNameArray.indexOf(filename)
      this.fileNameArray.splice(index, 1)
      this.fileContentArray.splice(index, 1)
      this.serialize.splice(index, 1)
      this.lastIndex--
    },
    // MOBILE SEULEMENT
    scanDocument ($event) {
      /* eslint-disable no-undef */
      let that = this
      this.locationTypeFile = 0
      var options = {
        quality: 10,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: true,
        correctOrientation: true
      }

      if (this.$engine.settings.get().ocrActivation === '1') {
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()

              reader.onloadend = function (e) {
                executeOCR(e)
              }
              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      } else {
        console.log('OCR Non Actif')
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()
              reader.onloadend = function (e) {
                that.fileContentArray.push(e.target.result)
              }

              let ca = that
              that.$f7.modal({
                title: 'Please enter the name of the scan',
                // text: 'Enter a name of draft',
                afterText: '<div class="item-input"><input class="inputnamescan" type="text"></div>',
                buttons: [
                  {
                    text: 'Cancel',
                    color: 'red',
                    onClick: function () {
                    }
                  },
                  {
                    text: 'Done',
                    onClick: function () {
                      var lab = ca.Dom7('.inputnamescan').val()
                      ca.fileNameArray.push(lab)
                    }
                  }
                ]
              })
              that.attachmentReference = ''
              that.attachmentId = ''

              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      }
      /* eslint-enable no-undef */
    },
    setFileTypeSelected () {
      const matches = [ 'RIB', 'CNI', 'CI', 'CARTE_IDENTITE', 'CARTE_GRISE', 'FACTURE', 'KBIS', 'JUSTIFICATIF', 'MEMORANDUM', 'CERTIFICAT' ]
      matches.forEach(element => {
        if (this.fileName.toUpperCase().startsWith(element)) {
          switch (element) {
            case 'RIB':
              this.fileTypeSelected = 'RIB'
              break
            case 'CNI':
            case 'CI':
            case 'CARTE_IDENTITE':
              this.fileTypeSelected = 'IDCARD'
              break
            case 'CARTE_GRISE':
              this.fileTypeSelected = 'REGISTRATION_CARD'
              break
            case 'FACTURE':
              this.fileTypeSelected = 'INVOICE'
              break
            case 'KBIS':
              this.fileTypeSelected = 'KBIS'
              break
            case 'JUSTIFICATIF':
              this.fileTypeSelected = 'PROOF_OF_ADDRESS'
              break
            case 'MEMORANDUM':
              this.fileTypeSelected = 'MEMORANDUM'
              break
            case 'CERTIFICAT':
              this.fileTypeSelected = 'CERTIFICATE_INCORPORATION'
              break
            default:
              this.fileTypeSelected = 'OTHER'
              break
          }
          this.fileTypeSelectedArray.push(this.fileTypeSelected)
        }
      })
    },
    setSerialize () {
      // this.serialize = {}
      let newSerialize = {}
      if (this.fileTypeSelected !== '') {
        let fields = documentSerialize[this.fileTypeSelected].fields
        this.serializeGet.push(fields)
        for (var i = 0; i < fields.length; i++) {
          newSerialize[fields[i].name] = ''
        }
        this.serialize.push(newSerialize)
        this.lastIndex = this.serialize.length - 1
      } else {
        this.serializeGet = []
      }
    },
    showFileSelectionWindow (fileType) {
      this.locationTypeFile = '1'
      if (fileType === '1') {
        this.Dom7(this.Dom7('.local-file-input')[this.Dom7('.local-file-input').length - 1]).click()
      }
    },
    validateForm () {
      let flagsList = {
        'recipientName': false,
        'recipientEmail': false,
        'folderId': false,
        'folderName': false,
        'fileTypeSelected': false,
        'fileNameArray': false
      }
      let mandatoryValues = ['recipientName', 'recipientEmail', 'fileTypeSelected', 'requestName']
      let regexpValues = {
        'recipientEmail': 'Email'
      }
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      if (this.fileNameArray.length === 0) {
        this.fileArrayError = true
        flagsList.fileNameArray = true
      }
      if (this.sharedFoldersConfig && this.sharedFolderType === '1' && this.folderId === '') {
        this.folderIdError = true
        flagsList.folderId = true
        this.folderNameError = false
        flagsList.folderName = false
      } else if (this.sharedFoldersConfig && this.sharedFolderType === '2' && this.folderName === '') {
        this.folderNameError = true
        flagsList.folderName = true
        this.folderIdError = false
        flagsList.folderId = false
      }
      flagsList = verifyRegexpValues(regexpValues, flagsList, this)
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    }
  }
}
</script>
<style scoped>
.dragDrop{
  height: 200px;
  border-radius: 6px;
  cursor: pointer;
}
.dragDropRest{
  background-color:white ;
  border: rgba(72, 21, 127, 0.7) dotted 2px;
}
.dragDropActive{
  background-color: rgba(72, 21, 127, 0.2);
  border: rgba(72, 21, 127, 0.7) dotted 2px;
}

.spinner-container{
  top: 50%;
  left: 50%;
  position: relative
}
</style>


// WEBPACK FOOTER //
// OCRScanTemplate.vue?46681876